module.exports = __webpack_public_path__ + "static/media/onions_hero.3a34f03e.jpg";